import { base, bsc, bscTestnet, mainnet, MainnetSupported, sepolia, SupportedChainId, SupportedChainIds, TestnetSupported } from './AppSupportChains';

export interface AppTokenWhitelistItem {
  address: `0x${string}`;
  symbol: string;
  chainIds: SupportedChainId[];
}

export const NativeAddress = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';

const defaultChainIds = SupportedChainIds as SupportedChainId[];

const AppTokenWhitelist: AppTokenWhitelistItem[] = [{ address: NativeAddress, symbol: '', chainIds: defaultChainIds }];

const addToken = (address: string | undefined, symbol: string, chainIds: SupportedChainId[]) => {
  if (!address) return;
  AppTokenWhitelist.push({ address: address as `0x${string}`, symbol, chainIds });
};

if (TestnetSupported) {
  addToken(import.meta.env.VITE_ETH_SEPOLIA_TUSDT_ADDRESS, 'tUSDT', [sepolia.id]);
  addToken(import.meta.env.VITE_ETH_SEPOLIA_TUSDC_ADDRESS, 'tUSDC', [sepolia.id]);
  addToken(import.meta.env.VITE_BSC_TESTNET_TUSDT_ADDRESS, 'tUSDT', [bscTestnet.id]);
  addToken(import.meta.env.VITE_BSC_TESTNET_TUSDC_ADDRESS, 'tUSDC', [bscTestnet.id]);
}

if (MainnetSupported) {
  AppTokenWhitelist.push(
    { address: '0xdAC17F958D2ee523a2206206994597C13D831ec7', symbol: 'USDT', chainIds: [mainnet.id] },
    { address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', symbol: 'USDC', chainIds: [mainnet.id] },

    { address: '0x55d398326f99059fF775485246999027B3197955', symbol: 'USDT', chainIds: [bsc.id] },
    { address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d', symbol: 'USDC', chainIds: [bsc.id] },

    // base
    { address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913', symbol: 'USDC', chainIds: [base.id] },
  );
}

export default AppTokenWhitelist;
